import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const LEASING_INTEREST_TYPE_DETAIL_DELETED = gql`
  subscription leasingInterestTypeDetailDeleted {
    leasingInterestTypeDetailDeleted {
      interestTypeDetailId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
